import React from "react";
import { Loader2, Hourglass } from "lucide-react";
import { useRetentionApply } from "./retention/useRetentionApply";
import { RetentionPlan, RetentionJob } from "./retention/RetentionBits";

const NUM = "admin-input w-20 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono";

function WindowInputs({ s }) {
  const disabled = s.busy || s.active;
  return (
    <div className="flex items-center gap-2 flex-wrap text-xs text-zinc-300">
      <span>live</span><input data-testid="retention-hot-input" type="number" min={1} max={365} value={s.hot} onChange={(e) => s.setHot(e.target.value)} className={NUM} />
      <span>days → archived</span><input data-testid="retention-archive-input" type="number" min={1} max={365} value={s.archive} onChange={(e) => s.setArchive(e.target.value)} className={NUM} />
      <span>days → gone</span>
      <button type="button" data-testid="retention-preview-btn" disabled={disabled} onClick={s.preview} className="px-3 py-1.5 text-xs border border-rose-700 text-rose-300 rounded-sm hover:border-rose-400 disabled:opacity-50 flex items-center gap-1.5">
        {s.busy && !s.plan ? <Loader2 size={12} className="animate-spin" /> : <Hourglass size={12} />} Preview apply to all sites…
      </button>
    </div>
  );
}

/** Settings → Article lifecycle: force one retention window onto every site and run the lifecycle now (in the worker). */
export default function RetentionApplyPanel({ status, onDone }) {
  const s = useRetentionApply(status, onDone);
  const windows = status?.retention?.windows || [];
  return (
    <div data-testid="retention-panel" className="space-y-3">
      <div data-testid="retention-current" className="text-[11px] text-zinc-500 mono">
        {windows.length ? windows.map((w) => `${w.sites} site(s) on ${w.hot_days}/${w.archive_days}d`).join(" · ") : "…"}
      </div>
      <WindowInputs s={s} />
      {s.plan && <RetentionPlan plan={s.plan} busy={s.busy} onRun={s.run} onCancel={s.cancelPlan} />}
      {s.job && <RetentionJob job={s.job} />}
      {s.err && <div data-testid="retention-error" className="text-xs text-red-400 border border-red-900/60 bg-red-950/40 px-3 py-2 rounded-sm font-mono">{s.err}</div>}
    </div>
  );
}
